<p-card styleClass="p-card-shadow mt-2">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>
    
        </p-toolbar>
        <p-table #miSurvey [value]="userWise"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'UserID',
        'Level_ID',
        'TotalApplication',
        'VerifiedApplication',
        'ReturnProcessApplication',
        'PendingEarly',
        'Pending_1Week',
        'Pending_Morethan_1Weeks',
        'RejectedApplication',
        'PVAmount',
        'PVArea',      
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'USER_WISE_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>               
                <th pSortableColumn="UserID">{{'USER_ID'| translate}}
                    <p-columnFilter type="text" field="UserID" display="menu"></p-columnFilter>
                    <p-sortIcon field="UserID"></p-sortIcon>
                </th>
                <th pSortableColumn="Level_ID">{{'LEVEL_ID'| translate}}
                    <p-columnFilter type="text" field="Level_ID" display="menu"></p-columnFilter>
                    <p-sortIcon field="Level_ID"></p-sortIcon>
                </th>
                <th pSortableColumn="TotalApplication">{{'TOTAL_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="TotalApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="TotalApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="VerifiedApplication">{{'VERIFIED_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="VerifiedApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="VerifiedApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="ReturnProcessApplication">{{'RETURN_PROCESS_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="ReturnProcessApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="ReturnProcessApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="PendingEarly">{{'PENDING_IN_TIME'| translate}}
                    <p-columnFilter type="text" field="PendingEarly" display="menu"></p-columnFilter>
                    <p-sortIcon field="PendingEarly"></p-sortIcon>
                </th>
                <th pSortableColumn="Pending_1Week">{{'PENDING_A_WEEK'| translate}}
                    <p-columnFilter type="text" field="Pending_1Week" display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_1Week"></p-sortIcon>
                </th>
                <th pSortableColumn="Pending_Morethan_1Weeks">{{'PENDING_MORE_THEN_A_WEEK'| translate}}
                    <p-columnFilter type="text" field="Pending_Morethan_1Weeks" display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_Morethan_1Weeks"></p-sortIcon>
                </th>
                <th pSortableColumn="RejectedApplication">{{'REJECTED_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="RejectedApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="RejectedApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="PVAmount">{{'PV_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="PVAmount" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVAmount"></p-sortIcon>
                </th>
                <th pSortableColumn="PVArea">{{'PV_AREA'| translate}}
                    <p-columnFilter type="text" field="PVArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVArea"></p-sortIcon>
                </th>           
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-userWise>
            <tr>
                <td>{{userWise.UserID}}</td>
                <td>{{userWise.Level_ID}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_totalApp(userWise.Level_ID,userWise.UserID)">{{userWise.TotalApplication}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(userWise.Level_ID,'Approved',userWise.UserID)">{{userWise.VerifiedApplication}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(userWise.Level_ID,'Incomplete',userWise.UserID)">{{userWise.ReturnProcessApplication}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(userWise.Level_ID,'early',userWise.UserID)">{{userWise.PendingEarly}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(userWise.Level_ID,'1Week',userWise.UserID)">{{userWise.Pending_1Week}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(userWise.Level_ID,'morethan_1Week',userWise.UserID)">{{userWise.Pending_Morethan_1Weeks}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_rejected(userWise.Level_ID,userWise.UserID)">{{userWise.RejectedApplication}}</a></td>
                <td>{{userWise.PVAmount}}</td>
                <td>{{userWise.PVArea}}</td>              
            </tr>
        </ng-template>
        <!-- <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td></td>
                <td >{{totalApp}}</td>
                <td >{{verfApp}}</td>
                <td >{{returnProcessApp}}</td>
                <td >{{onTime}}</td>
                <td >{{pendingByWeek}}</td>
                <td >{{pendingMoreThanWeek}}</td>
                <td >{{rejectedApp}}</td>
                <td >{{pvAmount}}</td>
                <td >{{pvArea}}</td>
            </tr>
            <tr>
                <td > Grand Total</td>
                <td></td>
                <td >{{grandTotalApp}}</td>
                <td >{{grandVerfApp}}</td>
                <td >{{grandReturnProcessApp}}</td>
                <td >{{grandOnTime}}</td>
                <td >{{grandPendingByWeek}}</td>
                <td >{{grandPendingMoreThanWeek}}</td>
                <td >{{grandRejectedApp}}</td>
                <td >{{grandPvAmount}}</td>
                <td >{{grandPvArea}}</td>
            </tr>
        </ng-template>     -->
        </p-table>
    </div>
    </p-card>
    <p-dialog class="drilldown_details" [baseZIndex]="-100" header="Drill Down User wise Physical Verification Report Of   {{approved_return}} Application of {{userName}}  "  [(visible)]="displayMaximizable" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-approved-incomplete-report  *ngIf="displayMaximizable" [drilldownDetails]="drilldownDetails"></app-drill-down-approved-incomplete-report>
    
   </p-dialog>
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down User wise Physical Verification Report Of Total Application of {{userName}} "  [(visible)]="displayMaximizable_totalApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-total-report  *ngIf="displayMaximizable_totalApp" [drilldownDetails]="drilldownDetails"></app-drill-down-total-report>
   
  </p-dialog>
  <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down User wise Physical Verification Report Of {{pendingType}} Application of {{userName}} "  [(visible)]="displayMaximizable_pendingApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-pending-report  *ngIf="displayMaximizable_pendingApp" [drilldownDetails]="drilldownDetails"></app-drill-down-pending-report>
   
  </p-dialog>
  <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down User wise Physical Verification Report Of Rejected Application of {{userName}} "  [(visible)]="displayMaximizable_rejectedApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-rejected-report  *ngIf="displayMaximizable_rejectedApp" [drilldownDetails]="drilldownDetails"></app-drill-down-rejected-report>
   
  </p-dialog>